export const alignRightColumns = [
  'float',
  'integer',
  'floatOrNull',
  'integer',
  'int_with_zero',
  'billing_format',
  'floatCurrency',
  'floatReportRawCurrency',
  'floatCurrencyColor',
  'outcomeCount',
  'highlightedFloat',
  'admPaymentDetails',
  'affPaymentDetails',
];
